import { useState } from "react";
import type { TLImageShape } from "@tldraw/tlschema";
import type { WorkspaceModel } from "./useWorkspace";
import { setSourceScale, sourceMeters } from "./source-scale";
export function PdfScaleControls({
  model,
  shape,
  close,
}: {
  model: WorkspaceModel;
  shape: TLImageShape;
  close: () => void;
}) {
  const asset =
    shape.props.assetId && model.editor.getAsset(shape.props.assetId);
  const knownWidth = Number(asset && asset.meta.pdfPaperWidthMm);
  const [width, setWidth] = useState(
    Number.isFinite(knownWidth) && knownWidth > 0
      ? String(Math.round(knownWidth * 10) / 10)
      : "",
  );
  const [ratio, setRatio] = useState("100");
  return (
    <div className="pdf-scale-controls">
      <strong>Drawing scale</strong>
      <p>
        {sourceMeters(model.editor, shape)
          ? String(shape.meta.calibration || "Scale set")
          : "Not to scale"}
      </p>
      <button
        onClick={() => {
          close();
          model.choose("calibrate");
        }}
      >
        Set from a known distance
      </button>
      <details>
        <summary>Use a printed scale</summary>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const mm = Number(width),
              denominator = Number(ratio);
            if (
              !Number.isFinite(mm * denominator) ||
              mm <= 0 ||
              denominator <= 0
            )
              return;
            const fraction = shape.props.crop
              ? shape.props.crop.bottomRight.x - shape.props.crop.topLeft.x
              : 1;
            setSourceScale(
              model.editor,
              shape,
              (mm * denominator * fraction) / 1000 / shape.props.w,
              `Original PDF · 1:${denominator}`,
            );
            close();
          }}
        >
          <label>
            Scale · 1:
            <input
              aria-label="PDF printed scale"
              type="number"
              min="1"
              max="100000"
              value={ratio}
              onChange={(e) => setRatio(e.target.value)}
              required
            />
          </label>
          <label>
            Original page width (mm)
            <input
              aria-label="Original PDF page width in millimetres"
              type="number"
              min="1"
              max="10000"
              step="0.1"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              required
            />
          </label>
          <small>
            Use the scale printed on this page. For resized or scanned plans,
            calibrate a known distance instead.
          </small>
          <button type="submit">Apply scale</button>
        </form>
      </details>
      {sourceMeters(model.editor, shape) > 0 && (
        <button
          onClick={() => {
            setSourceScale(model.editor, shape, 0, "Not to Scale");
            close();
          }}
        >
          Clear scale
        </button>
      )}
    </div>
  );
}
